/**
 * Static translation key maps.
 *
 * Avoids runtime concat (e.g. `t(concat "types.item." @type)`) by mapping each
 * value to its full, statically-analysable translation key. This makes keys
 * visible to the translation validator instead of disappearing into a dynamic
 * string concatenation.
 */

// ── Item types ────────────────────────────────────────────────────────────────

const ITEM_TYPE_TR_KEYS: Record<string, string> = {
  movie: 'types.item.movie',
  tv_show: 'types.item.tv_show',
  book: 'types.item.book',
  music: 'types.item.music',
  podcast: 'types.item.podcast',
  recipe: 'types.item.recipe',
  video_game: 'types.item.video_game',
  place: 'types.item.place',
  product: 'types.item.product',
  person: 'types.item.person',
  brand: 'types.item.brand',
  event: 'types.item.event',
  unknown: 'types.item.unknown',
};

/** Returns the translation key for a singular item type label. */
export function itemTypeTrKey(type: string | null | undefined): string {
  return ITEM_TYPE_TR_KEYS[type ?? ''] ?? type ?? '';
}

// ── Pipeline step labels ───────────────────────────────────────────────────────

export const STEP_TR_KEYS: Record<string, string> = {
  pending: 'pipeline.step.pending',
  downloading: 'pipeline.step.downloading',
  transcribing: 'pipeline.step.transcribing',
  analyzing: 'pipeline.step.analyzing',
  enriching: 'pipeline.step.enriching',
  completed: 'pipeline.step.completed',
  done: 'pipeline.step.done',
};

// ── Fine-grained pipeline step labels (SSE v2 step events) ────────────────────

export const FINE_STEP_TR_KEYS: Record<string, string> = {
  'fetch-metadata': 'pipeline.fineStep.fetchMetadata',
  download: 'pipeline.fineStep.download',
  transcribe: 'pipeline.fineStep.transcribe',
  'describe-image': 'pipeline.fineStep.describeImage',
  'download-photos': 'pipeline.fineStep.downloadPhotos',
  'describe-photos': 'pipeline.fineStep.describePhotos',
  summarize: 'pipeline.fineStep.summarize',
  'extract-entities': 'pipeline.fineStep.extractEntities',
  enrich: 'pipeline.fineStep.enrich',
  'persist-mentions': 'pipeline.fineStep.persistMentions',
  'extract-recipes': 'pipeline.fineStep.extractRecipes',
  'fetch-ratings': 'pipeline.fineStep.fetchRatings',
};

// ── Pipeline description keys ─────────────────────────────────────────────────

export const STEP_DESCRIPTION_TR_KEYS: Record<string, string> = {
  pending: 'pipeline.description.pending',
  downloading: 'pipeline.description.downloading',
  transcribing: 'pipeline.description.transcribing',
  analyzing: 'pipeline.description.analyzing',
  enriching: 'pipeline.description.enriching',
  failed: 'pipeline.description.failed',
  not_found: 'pipeline.description.not_found',
};
